import React, { ReactNode } from 'react';
import cx from 'classnames';
import _uniq from 'lodash/uniq';
import TransitionGroup from 'react-transition-group/TransitionGroup';

import Toast from './Toast';
import ToastActionTypes from './types/ToastActionTypes';

import './Toasts.css';

type ToastsProps = {
  toasts: {
    id: number;
    type: keyof typeof ToastActionTypes;
    headline: string | ReactNode;
    dek?: string | ReactNode;
    className?: string;
    containerClass: string;
    autoDismissInSeconds: number;
    dismissText: string | ReactNode;
    onDismiss: () => void;
  }[];
  onRemoveToast: (id: number, timeoutMs?: number) => void;
};

/**
 * @deprecated components/Toasts is deprecated, use components/ToastsV2
 */
const Toasts: React.FC<ToastsProps> = ({ toasts, onRemoveToast }) => {
  const remove = (id: number, timeout?: number) => {
    setTimeout(() => onRemoveToast(id), timeout);
  };

  const containerClasses = _uniq(toasts.map((toast) => toast.containerClass));
  const optClass = containerClasses.join(' ');

  const className = cx('zui-toasts', optClass);
  return (
    <TransitionGroup className={className}>
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} onRemove={remove} />
      ))}
    </TransitionGroup>
  );
};

export default Toasts;
